import React from 'react';
import { FileCheck } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

export const VerificationHeader = () => {
  const { translations } = useLanguage();

  return (
    <div className="flex items-center gap-3">
      <div className="p-2 bg-primary-50 rounded-lg">
        <FileCheck className="text-primary-500" size={24} />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          {translations?.verificationApproval?.header?.title || 'Verification Approval'}
        </h1>
        <p className="text-gray-500 mt-1">
          {translations?.verificationApproval?.header?.subtitle || 'Review and approve verification requests'}
        </p>
      </div>
    </div>
  );
};